export const MIXPANEL_EVENTS = {
  // Analysis events
  RUN_ANALYSIS: 'run_analysis',
  RENAME_ANALYSIS: 'rename_analysis',
  VIEW_PREVIOUS_ANALYSIS: 'view_previous_analysis',
  VIEW_FRAME_ANALYSIS: 'view_frame_analysis',
  COMPARE_ANALYSES_CLICKED: 'compare_analyses_clicked',
  PRINT_ANALYSIS_RESULTS: 'print_analysis_results',
  ENHANCEMENT_SUGGESTIONS: 'enhancement_suggestions',

  // Authentication events
  SIGNED_IN: 'signed_in',
  SIGNED_OUT: 'signed_out',

  // Page tracking
  PAGE_VIEW: 'page_view',
} as const

// Standard property keys for consistency
export const MIXPANEL_PROPERTIES = {
  // File properties
  FILE_TYPE: 'file_type',

  // Page properties
  PAGE_PATH: 'page_path',
  PAGE_SEARCH: 'page_search',
  PAGE_HASH: 'page_hash',
  FULL_PATH: 'full_path',
  PAGE_TITLE: 'page_title',

  // User properties
  USER_EMAIL: '$email',
  USER_FIRST_NAME: '$first_name',
  USER_LAST_NAME: '$last_name',

  // Analysis properties
  ANALYSIS_ID: 'analysis_id',
  ANALYSIS_TYPE: 'analysis_type',
} as const

export type MixpanelEvent =
  (typeof MIXPANEL_EVENTS)[keyof typeof MIXPANEL_EVENTS]
export type MixpanelProperty =
  (typeof MIXPANEL_PROPERTIES)[keyof typeof MIXPANEL_PROPERTIES]
